import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

export type SuperUserManualValidationQueryCode = {
  reason: string;
  fieldglassId: string;
  activityItemCode: string;
  subscriptionId: string;
  zIdentifier: string;
  validationExpirationDate?: Date;
  hasInfiniteLifetime?: boolean;
};

const fetchSuperManualValidation = async (
  payload: SuperUserManualValidationQueryCode,
) => {
  const { data } = await apiInputService.post("manual-validation", payload);

  return data;
};

export const useSuperUserManualValidation = (options?: any) => {
  return useMutation(fetchSuperManualValidation, {
    ...options,
  });
};
